<template>
    <div class="offers-list" v-if="offers.length">
        <div class="offer-items">

            <offer-slot
                v-for="offer in offers"
                v-bind:key="offer.id"
                :rules="offer.getAvailableDaysAndTimes()"
                :title="offer.name"
                :description="offer.description"
                :validFrom="offer.validFrom ? DateService.friendlyDate(offer.validFrom) : null"
                :validTo="offer.validTo ? DateService.friendlyDate(offer.validTo) : null"
                :minPax="offer.minimumPeople"
                :maxPax="offer.maximumPeople"
                :offer="offer">
            </offer-slot>

        </div>
    </div>
</template>

<script>
  import DateService from '../services/DateService'
  import offerSlot from './offerSlot'

  export default {
    name: 'offersList',
    props: [
      'venue'
    ],
    components: {
      offerSlot
    },
    data () {
      return {
        DateService,
        offers: []
      }
    },
    mounted () {
      const allOffers = this.venue.offers

      this.offers = allOffers.filter((offer) => {
        return offer.shouldDisplay(this.$root.dmnOptions.from)
      })
    }
  }
</script>



// WEBPACK FOOTER //
// offersList.vue?2b87b583